// extracted by mini-css-extract-plugin
export const root = "about-copy-module--root--17j2m";